import { OrthographicViewport } from "@deck.gl/core";
import { LRUCache } from "lru-cache";
export const createDeduplicate = (toCacheKey) => (values, opts = {}) => (Object.values(values.reduce((acc, value) => ({ ...acc, [toCacheKey(value, opts.precision)]: value }), {})));
export const range = (optsOrLength, offset = 0) => {
    const start = (typeof optsOrLength === 'number')
        ? offset
        : optsOrLength.start;
    const endInclusive = (typeof optsOrLength === 'number')
        ? optsOrLength + offset - 1
        : optsOrLength.endInclusive;
    const integerCount = Math.ceil(endInclusive - start + 1);
    return [...Array(integerCount).keys()].map(idx => idx + start);
};
export const linearInterpolate = (start, end, percentile) => start + ((end - start) * percentile);
export const memoize = (getCacheKey, fn) => {
    const cache = new LRUCache({ max: 50000 });
    return (...i) => {
        const cacheKey = getCacheKey(...i);
        if (cache.has(cacheKey))
            return cache.get(cacheKey);
        const result = fn(...i);
        cache.set(cacheKey, result);
        return result;
    };
};
export const viewportStateFromViewState = (viewState) => {
    const viewport = new OrthographicViewport(viewState);
    const topLeft = viewport.unproject([0, 0]);
    const bottomRight = viewport.unproject([viewport.width, viewport.height]);
    return {
        viewportLeft: topLeft[0],
        viewportTop: topLeft[1],
        viewportRight: bottomRight[0],
        viewportBottom: bottomRight[1],
    };
};
//# sourceMappingURL=_common.js.map